import { schema } from "normalizr";
import createProfileRecord from "records/brand-profile";

export const BrandProfile = new schema.Entity(
    "brandProfile",
    {},
    {
        idAttribute: "id",
    }
);

BrandProfile.record = createProfileRecord;
